import React from "react";
import { LanguageSwitcher } from "@pws/coquille-i18n";

/**
 * FR / EN toggle — wraps @pws/coquille-i18n LanguageSwitcher.
 * Must be used inside I18nProvider.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.testId]
 */
export function LanguageToggle({ className = "gsd-language-toggle", testId = "gsd-language-toggle" }) {
  return <LanguageSwitcher className={className} testId={testId} />;
}
